import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const ForRniSection = ({
  slackChannel,
  setSlackChannel,
  memo,
  setMemo,
}: {
  slackChannel: string;
  setSlackChannel: (v: string) => void;
  memo: string;
  setMemo: (v: string) => void;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit.for_rni.title")}
      rows={[
        {
          label: t("quest_edit.for_rni.form.slack_channel.label"),
          children: (
            <TextField
              size="small"
              placeholder={t(
                "quest_edit.for_rni.form.slack_channel.placeholder",
              )}
              sx={{ width: "50%" }}
              value={slackChannel}
              onChange={(e) => setSlackChannel(e.target.value)}
            ></TextField>
          ),
        },
        {
          label: t("quest_edit.for_rni.form.memo.label"),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t("quest_edit.for_rni.form.memo.placeholder")}
              fullWidth
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
            ></TextField>
          ),
        },
      ]}
    />
  );
};

export default ForRniSection;
